import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import '../styles/main.scss'

import SignedOutPage from './SignedOutPage';
import SignedInPage from './SignedInPage';
import ListSkeletonLoader from '../components/Layout/ListSkeletonLoader';

function MainPage({ special, workspaceHint }) {

    // main page is for setting up our stuff

    const { isAuthenticated, isLoading: auth0Loading, getAccessTokenSilently, user } = useAuth0();
    const [uStatus, setUStatus] = useState();
    const [userHasJustSignedUp, setUserHasJustSignedUp] = useState(false);

    let [loading, setLoading] = useState(true);

    const handleSignUp = (resp) => {
        setUserHasJustSignedUp(true);
        let returnedInfo = { ...resp.idTokenClaims, state: 'JUST_SIGNED_UP' };
        setUStatus({ userInfo: returnedInfo });
    }   

    const getUserStatus = async () => {
        if (!uStatus && isAuthenticated) {
            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                        scope: 'read:current_user'
                    }
                });
                if (token) {
                    let resp = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/users/${user.sub}/status`, {
                        method: 'GET',
                        headers: {
                            "Authorization": "Bearer " + token
                        }
                    });
                    if (resp.ok) {
                        let userStatus = await resp.json();
                        setUStatus(userStatus);
                    }
                }
            } catch (error) {
                // handle error (e.g. show toast or set error state)
            }
        }
    }

    useEffect(() => {
        if (uStatus && uStatus.userInfo && uStatus.userInfo.state && (uStatus.userInfo.state !== 'ACTIVE' && uStatus.userInfo.state !== 'PENDING_APPROVAL')) {
            setLoading(true);
        }
    }, [uStatus]);

    useEffect(() => {
        if (auth0Loading) return;
        if (isAuthenticated && userHasJustSignedUp === false) {
            setLoading(true);
            getUserStatus().finally(() => {
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, auth0Loading, userHasJustSignedUp]);

    return (
        loading ?
            <ListSkeletonLoader classes={'m-i-08 m-b-08'} preview={false} />
        : 
            isAuthenticated && !['PENDING_APPROVAL', 'JUST_SIGNED_UP'].includes(uStatus?.userInfo?.state) && uStatus?.userInfo?.status !== "unauthenticated" ?
                <SignedInPage special={special} />
            :
                <SignedOutPage special={special} userOnboard={uStatus} passedSignUp={handleSignUp} />
    )
}

export default MainPage;
